export default __webpack_public_path__ + "static/media/Cleaning.ec9a6eb2.svg";